/* eslint-disable */
import girl1 from '../assets/svg/testimonials/girl1.svg'
import girl2 from '../assets/svg/testimonials/girl2.svg'
import girl3 from '../assets/svg/testimonials/girl3.svg'
import boy1 from '../assets/svg/testimonials/boy1.svg'
import boy2 from '../assets/svg/testimonials/boy2.svg'
import boy3 from '../assets/svg/testimonials/boy3.svg'



export const testimonialsData = [
    {
        id: 1,
        name: 'Asrak Shohas',
        title: 'Web Developer',
        text: "Building my own portfolio could've never been easier than this. The only areas I'm good at are Math, Jokes and Dance.",
        image: boy2
    },
    {
        id: 2,
        name: 'Akif',
        title: 'Web Developer',
        text: "This is the only thing that I didn't have to spend time to sort out. It's tidy all by itself.",
        image: boy2
    },
    {
        id: 3,
        name: 'Kafil Ora',
        title: 'Massuese',
        text: "Heard of the song 'Smelly Cat!!' ? This website made it viral. Plus portfolio is the only thing that Ursula doesn't have :)",
        image: girl1
    },
    {
        id: 4,
        name: 'Joya Tribbiani',
        title: 'Actor',
        text: "Making my portfolio with this helped me get my role as 'Dr. Drake Ramoray' in 'Days Of Our Lives'. You guys are the best !",
        image: boy1
    },
   
  
]

